import { Component } from '@angular/core';
import { LanguageService } from '@uxdf/direct-shared-lib';
import { Store } from '@ngrx/store';
import { setLocaleAction } from '@uxdf/locale-manager';

@Component({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent {
  constructor(private readonly language: LanguageService, private readonly store: Store<any>) {
    const browserLang = navigator.language.replace('-', '_') || 'en_US';
    const availableLang = Object.keys(this.language.supportedLocales).find(locale => locale === browserLang);

    this.store.dispatch(setLocaleAction({ bcpLocale: availableLang }));
  }
}
